import { getUrlParams } from '@/utils'

export const timeRnage = {
  data() {
    return {
    }
  },
  methods: {},
};

export const paramsObj = {
  data() {
    return {}
  },
  computed: {
    paramsObj() {
      return {
        plat: this.$store.state.user.plat ? this.$store.state.user.plat : getUrlParams('plat'),
        catId: this.$store.state.user.catId,
        start: this.$store.state.user.start,
        end: this.$store.state.user.end,
        tsType: this.$store.state.user.tsType,
        picType: this.$store.state.user.picType,
        question_time_typ: this.$store.state.user.question_time_typ,
        navData: this.$store.state.user.navData,
        parentCatId: this.$store.state.user.parentCatId,
        url_id: this.$store.state.user.url_id
      }
    },
  },
  watch: {}
};

export const urlParams = {
  data () {
    return {}
  },
  computed: {
    urlParams() {
      return {
        plat: this.$store.state.user.plat ? this.$store.state.user.plat : getUrlParams('plat'),
        brand_id: this.$store.state.user.brandId,
        cat_id: this.$store.state.user.catId,
        item_id: this.$store.state.user.itemId,
        sku_id: this.$store.state.user.skuId,
        content_word: this.$store.state.user.contentWord,
        shop_id: this.$store.state.user.shopId,
        custom_filters: this.$store.state.user.customFilters ? JSON.stringify(this.$store.state.user.customFilters) : '',
        item_analyse: this.$store.state.user.itemAnalyse,
        //attr_filters
        price_max: this.$store.state.user.priceMax,
        price_min: this.$store.state.user.priceMin,
        title_word: this.$store.state.user.titleWord,
        title_typ: this.$store.state.user.titleTyp,
        parent_cat_id: this.$store.state.user.parentCatId,
        fx_url_id: this.$store.state.user.fxUrlId,
      }
    }
  }
}